import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import * as Yup from "yup";
import { useFormik } from "formik";
import clsx from "clsx";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useDispatch } from "react-redux";
import ErrorText from "../../core/components/error-text";
import "./style.scss";
import { acceptUserInvitation, getInvitedUserDetails } from "../../core/data/redux/manageUser/_manageUserAction";
import { capitalizeFullRole } from "../../constants/common";

// const validationSchema = Yup.object().shape({
//   name: Yup.string().required("Name is required"),
//   phone: Yup.string()
//     .required("Phone number is required")
//     .matches(/^[0-9]{10,15}$/, "Phone must be 10–15 digits"),
//   password: Yup.string()
//     .required("Password is required")
//     .min(8, "Password must be at least 8 characters")
//     .matches(/[A-Z]/, "Must contain an uppercase letter")
//     .matches(/[a-z]/, "Must contain a lowercase letter")
//     .matches(/[0-9]/, "Must contain a number")
//     .matches(/[@#%!-]/, "Must contain a symbol"),
//   confirmPassword: Yup.string()
//     .required("Confirm Password is required")
//     .oneOf([Yup.ref("password")], "Passwords must match"),
// });

const fullValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  phone: Yup.string()
    .required("Phone number is required")
    .matches(/^[0-9]{10,15}$/, "Phone must be 10–15 digits"),
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(/[A-Z]/, "Must contain an uppercase letter")
    .matches(/[a-z]/, "Must contain a lowercase letter")
    .matches(/[0-9]/, "Must contain a number")
    .matches(/[@#%!-]/, "Must contain a symbol"),
  confirmPassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref("password")], "Passwords must match"),
});

const partialValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  phone: Yup.string().optional(),
  password: Yup.string().optional(),
  confirmPassword: Yup.string().optional(),
});

const initialValues = {
  name: "",
  email: "",
  role: "",
  phone: "",
  password: "",
  confirmPassword: "",
}


const AcceptInvitation = () => {
  const route = all_routes;
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const token: any = params.get("token");

  const [loading, setLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [invitedUser, setInvitedUser] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [userExists, setUserExists] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible((prev) => !prev);
  };

  // Fetch invited user details on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await dispatch(getInvitedUserDetails({ uuid: token }));
        const invitedUserData = response?.payload?.data;

        if (invitedUserData) {
          setInvitedUser(invitedUserData);
          setUserExists(invitedUserData.user_exists || false);
          formik.setValues({
            name: invitedUserData.name || "",
            email: invitedUserData.email || "",
            role: invitedUserData.role || "",
            phone: "",
            password: "",
            confirmPassword: "",
          });
        }
        else {
          setError("Invalid or expired invitation link.");
        }
      } catch (err: any) {
        setError(err?.response?.data?.message || "Failed to fetch invitation details.");
      }
    };
    fetchData();
  }, [dispatch, token]);


  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    // validationSchema,

    validate: (values) => {
      const schemaToUse = userExists ? partialValidationSchema : fullValidationSchema;
      const errors: any = {};
      try {
        schemaToUse.validateSync(values, { abortEarly: false });
      } catch (validationError: any) {
        if (validationError.inner) {
          validationError.inner.forEach((error: any) => {
            errors[error.path] = error.message;
          });
        }
      }
      return errors;
    },


    onSubmit: async (values, { setSubmitting }) => {
      setLoading(true);
      try {
        const payload = {
          name: values.name,
          role: values.role,
          email: values.email,
          phone: values.phone,
          password: values.password,
          status: "accept",
        };

        const result = await dispatch(acceptUserInvitation({ values: payload, uuid: token }));
        console.log('result?.payload ======== ',result?.payload);
        
        if (result?.payload?.success) {
          toast.success(result?.payload?.message || "Invitation accepted successfully");
          navigate(route.login);
        }
      }
      catch (error) {
        if (error instanceof AxiosError) {
          toast.error(error.response?.data?.error);
        }
      } finally {
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper authendication-pages">
        {/* Page Content */}
        <div className="content">
          <div className="container wrapper no-padding">
            <div className="row no-margin align-items-stretch">
              <div className="col-12 col-sm-12 col-md-12 col-lg-8 no-padding d-flex">
                <div className="banner-bg login">
                  <div className="row h100 pb-0">
                    <div className="col-sm-10 col-md-12 col-lg-12">
                      <div className="row h-100">
                        <div className="col-md-12 h-100">
                          <img
                            src="/assets/img/authImg.jpg"
                            className="object-fit-cover img-fluid w-100 h-100"
                            alt="authImg"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-12 col-lg-4 no-padding">
                <div className="dull-pg shadow-card w-100">
                  <div className="row no-margin d-flex align-items-center justify-content-center">
                    <div className="col-sm-10 col-md-10 col-lg-11 mx-auto">

                      <div className="Accept-Invitation">
                        <h2 className="text-center">Accept Invitation</h2>

                        {error ? (
                          <p className="text-center text-danger mt-5">{error}</p>
                        ) : (
                          <>
                            <p className="text-center">
                              {invitedUser?.invited_by ? capitalizeFullRole(invitedUser?.invited_by) : "Someone"} has invited you to join TREC Nest as a {invitedUser?.role ? capitalizeFullRole(invitedUser?.role) : "member"}.
                              Accept the invitation to get started.
                            </p>

                            <div className="tab-content" id="myTabContent">
                              <div
                                className="tab-pane fade show active"
                                id="user"
                                role="tabpanel"
                                aria-labelledby="user-tab"
                              >
                                <form onSubmit={formik.handleSubmit}>
                                  <div className="form-group">
                                    <label> Name</label>
                                    <div className="pass-group group-img  iconLeft email position-relative">
                                      <input
                                        type="text"
                                        name="name"
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                        disabled={userExists}
                                        placeholder="Enter your name"
                                        className={clsx("form-control commonInput pass-input ", {
                                          "border border-danger": formik.touched.name && formik.errors.name
                                        })}
                                      />

                                      <ErrorText show={formik.touched.name && formik.errors.name} message={formik.errors.name} />
                                    </div>
                                  </div>

                                  <div className="form-group">
                                    <label>Email</label>
                                    <input
                                      className="form-control commonInput"
                                      type="email"
                                      value={formik.values?.email}
                                      disabled
                                    />
                                  </div>

                                  <div className="form-group role form-control commonInput">
                                    <label>Role</label>
                                    {(formik.values?.role?.toLowerCase() === "spouse") &&
                                      <div className="me-3">
                                        <input
                                          type="radio"
                                          className=""
                                          checked={formik.values?.role?.toLowerCase() === "spouse"}
                                          readOnly
                                        />
                                        <label className="radio-label">Spouse</label>
                                      </div>
                                    }

                                    {(formik.values?.role?.toLowerCase() === "tax_professional") &&
                                      <div className="me-3">
                                        <input
                                          type="radio"
                                          checked={formik.values?.role?.toLowerCase() === "tax_professional"}
                                          readOnly
                                        />
                                        <label className="radio-label">Tax Professional</label>
                                      </div>
                                    }
                                  </div>

                                  {!userExists && (
                                    <div className="form-group">
                                      <label> Phone Number</label>
                                      <div className=" position-relative">
                                        <input
                                          type="text"
                                          name="phone"
                                          value={formik.values?.phone}
                                          onChange={formik.handleChange}
                                          placeholder="Phone Number"
                                          className={clsx("form-control commonInput pass-input ", {
                                            "border border-danger": formik.touched.phone && formik.errors.phone
                                          })}
                                        />
                                        <ErrorText show={formik.touched.phone && formik.errors.phone} message={formik.errors.phone} />
                                      </div>
                                    </div>
                                  )}

                                  {!userExists && (
                                    <div className="form-group">
                                      <label>Password</label>
                                      <div className="pass-group group-img">
                                        <i
                                          className={`toggle-password ${passwordVisible ? "feather-eye" : "feather-eye-off"}`}
                                          onClick={togglePasswordVisibility}
                                          style={{
                                            borderLeft: "1px solid",
                                            paddingLeft: 14,
                                          }}
                                        />
                                        <input
                                          type={passwordVisible ? "text" : "password"}
                                          placeholder="Password"
                                          {...formik.getFieldProps("password")}
                                          className={clsx(
                                            "form-control commonInput bg-transparent",
                                            {
                                              "border border-danger":
                                                formik.touched.password &&
                                                formik.errors.password,
                                            }
                                          )}
                                        />
                                      </div>
                                      <ErrorText
                                        show={
                                          formik.touched.password &&
                                          formik.errors.password
                                        }
                                        message={formik.errors?.password}
                                      />
                                    </div>
                                  )}

                                  {!userExists && (
                                    <div className="form-group">
                                      <label>Confirm Password</label>
                                      <div className="pass-group group-img iconLeft position-relative">
                                        <i
                                          className={`toggle-password ${confirmPasswordVisible ? "feather-eye" : "feather-eye-off"}`}
                                          onClick={toggleConfirmPasswordVisibility}
                                          style={{
                                            borderLeft: "1px solid",
                                            paddingLeft: 14,
                                          }}
                                        />
                                        <input
                                          type={confirmPasswordVisible ? "text" : "password"}
                                          placeholder="Confirm Password"
                                          {...formik.getFieldProps("confirmPassword")}
                                          className={clsx(
                                            "form-control commonInput pass-input ",
                                            {
                                              "border border-danger":
                                                formik.touched.confirmPassword &&
                                                formik.errors.confirmPassword,
                                            }
                                          )}
                                        />
                                      </div>
                                      <ErrorText
                                        show={
                                          formik.touched.confirmPassword &&
                                          formik.errors.confirmPassword
                                        }
                                        message={formik.errors?.confirmPassword}
                                      />
                                    </div>
                                  )}

                                  <button
                                    type="submit"
                                    className="btn btn-primary primaryButton register-btn d-inline-flex justify-content-center align-items-center w-100 btn-block"
                                  >
                                    Accept
                                  </button>
                                </form>
                                {/* /Login Form */}
                              </div>
                            </div>
                          </>
                        )}
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
      {/* /Main Wrapper */}
    </>
  );
};

export default AcceptInvitation;
